module.exports = __webpack_public_path__ + "static/media/img-meter.8e036068.png";